import { render, staticRenderFns } from "./grandShine.vue?vue&type=template&id=abd5f0d2"
import script from "./grandShine.vue?vue&type=script&lang=js"
export * from "./grandShine.vue?vue&type=script&lang=js"
import style0 from "./grandShine.vue?vue&type=style&index=0&id=abd5f0d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports